export default {
	methods: {
		vLink (routeName, params, options = {}) {
			if (! params) {
				params = {}
			}

			this.$inertia.visit(this.route(routeName, params), options)
		}
	}
}
